export default __webpack_public_path__ + "files/BBM8.pdf";